import { IBaseAction, IBaseState, TAppError } from '@/store/types/base.state';

import { IPaginateElements, IPagination } from '@/store/types/search.types';

import { IUser } from '@/features/user/store/user.model';

export enum UsersActionTypes {
  GET_USERS = 'USER.GET_USERS',
  GET_USERS_SUCCESS = 'USER.GET_USERS_SUCCESS',
  GET_USERS_FAIL = 'USER.GET_USERS_FAIL',
}

export interface IUsersAction extends IBaseAction {
  type: typeof UsersActionTypes.GET_USERS;
}

export interface IUsersActionSuccessAction extends IBaseAction {
  type: typeof UsersActionTypes.GET_USERS_SUCCESS;
  users: Array<IUser>;
  pagination: IPagination;
}

export interface IUsersActionFailAction extends IBaseAction {
  type: typeof UsersActionTypes.GET_USERS_FAIL;
  error: TAppError;
}

export type TUsersAction = IUsersAction | IUsersActionSuccessAction | IUsersActionFailAction;

export interface IUsersState extends IBaseState {
  paginateUsers: IPaginateElements<IUser>;
}
